import User from './userType';

const emptyUser: User = {
  UserUUID: '',
  FirstName: '',
  LastName: '',
  Email: '',
  OrganizationUUID: '',
  Role: '',
  Image: '',
  TeamUUID: '',
};

export default emptyUser;
